import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-submit-button',
    templateUrl: './submit-button.component.html',
    styleUrls: ['./submit-button.component.scss'],
    standalone: false
})
export class SubmitButtonComponent {
  @Input() buttonText: string = 'Continue';
  @Output() buttonClick = new EventEmitter<void>();
  @Input() isFormValid: boolean | null;
  @Input() inputType: string;
  constructor() {}

  emitButtonClick(): void {
    this.buttonClick.emit();
  }
}
